import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader, Button } from "semantic-ui-react";
import { Form } from "semantic-ui-react";
import { TitleCase } from "../../common";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordConfirm: "",
      error: false,
      errorMessage: "",
      submitted: false
    };
  }

  ChangePassword(e) {
    e.preventDefault();
    if (this.props.isConnected) {
      this.setState({ submitted: true });
      if (this.state.password !== this.state.passwordConfirm) {
        this.setState({ error: true, errorMessage: "Passwords do not match!" });
      } else {
        if (this.state.password.trim() === "") {
          this.setState({
            error: true,
            errorMessage: "Password cannot be blank!"
          });
        } else {
          this.setState({ error: false, errorMessage: "" });
          this.props.onChangePassword(this.state.password);
        }
      }
    }
  }

  updateInputValue(e) {
    var change = {};
    change[e.target.id] = e.target.value;
    this.setState(change);
  }

  renderError() {
    if (!this.props.isConnected) {
      return (
        <div
          style={{
            textAlign: "center",
            fontSize: 12,
            color: "rgb(255, 51, 51)"
          }}
        >
          Connection is offline
        </div>
      );
    }

    if (
      (this.state.error && !this.state.submitted) ||
      (this.state.submitted && this.state.errorMessage !== "")
    )
      return (
        <div
          style={{
            textAlign: "center",
            width: "100%",
            position: "relative",
            top: "-10px",
            marginBottom: 10,
            fontSize: 12,
            color: "rgb(255, 51, 51)"
          }}
        >
          {this.state.errorMessage}
        </div>
      );

    return <div></div>;
  }

  renderChangePassword() {
    if (this.props.isLoading) {
      return (
        <div>
          <br />
          <br />
          <br />
          <Loader
            active
            size="large"
            style={{ color: "#33ae8b" }}
            inline="centered"
          ></Loader>
        </div>
      );
    }

    if (this.props.passwordChanged) {
      return (
        <div
          style={{
            textAlign: "center",
            width: "100%",
            position: "relative",
            top: "50px",
            fontWeight: "bold",
            fontSize: "15px"
          }}
        >
          Password has been changed.
        </div>
      );
    }
    return (
      <form onSubmit={this.ChangePassword.bind(this)}>
        <div style={{ width: "100%" }} className="ui form">
          <Form.Field>
            {this.renderError()}
            <label style={{ fontWeight: "bold", fontSize: "15px" }}>
              {TitleCase("Enter new password")}
            </label>
            <div>
              <input
                autoFocus
                style={{ width: "100%" }}
                type="password"
                value={this.state.password}
                id="password"
                onChange={e => this.updateInputValue(e)}
              />
            </div>
            <br />
            <label style={{ fontWeight: "bold", fontSize: "15px" }}>
              {TitleCase("Confirm password")}
            </label>
            <div>
              <input
                style={{ width: "100%" }}
                type="password"
                value={this.state.passwordConfirm}
                id="passwordConfirm"
                onChange={e => this.updateInputValue(e)}
              />
            </div>
            <br />
            <div>
              <Button
                style={{ width: "100%" }}
                active
                className="ui button"
                role="button"
                onClick={this.ChangePassword.bind(this)}
              >
                Change password
              </Button>
            </div>
          </Form.Field>
        </div>
      </form>
    );
  }

  render() {
    return <div>{this.renderChangePassword()}</div>;
  }
}

ChangePassword.propTypes = {
  storeColour: PropTypes.object,
  passwordChanged: PropTypes.bool,
  isLoading: PropTypes.bool,
  tablet: PropTypes.bool
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js